/* script */
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from '../../../../frontend/views/components/TransitionExpand.vue'
import { debounce } from 'turtledash'

const __vue_script__ = ({
  name: 'BannerGeneral',
  components: {
    TransitionExpand
  },
  data: () => ({
    ephemeral: {
      message: null,
      icon: null,
      severity: null
    }
  }),
  methods: {
    // To be used by parent. Example:
    // this.$refs.bannerGeneral.show(L('Trying to reconnect...'), 'wifi')
    clean () {
      this.ephemeral.message = ''
      this.ephemeral.icon = ''
      this.ephemeral.severity = ''
    },
    show (message, icon) {
      this.ephemeral.message = message
      this.ephemeral.icon = icon
      this.ephemeral.severity = 'neutral'
    },
    danger (message, icon) {
      this.ephemeral.message = message
      this.ephemeral.icon = icon
      this.ephemeral.severity = 'danger'
    },
    severity () {
      return this.ephemeral.severity
    },
    debouncedShow ({ message, icon, seconds, clearWhen }   
                                                                           
     ) {
      let clearBannerTimer
      return debounce((...args) => {
        const clearBanner = () => {
          if (clearWhen()) {
            if (this.severity() !== 'danger') {
              this.clean()
            }
            clearBannerTimer = undefined
          } else {
            // after first n seconds, check every half a second for clearWhen to change
            setTimeout(clearBanner, 500)
          }
        }
        if (!clearBannerTimer && !clearWhen()) {
          this.show(message(...args), icon)
          clearBannerTimer = setTimeout(clearBanner, 1000 * seconds)
        }
      }, 1000 * seconds)
    }
  }
}        )

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition-expand", [
    _vm.ephemeral.message
      ? _c(
          "div",
          {
            staticClass: "l-banner",
            class: "is-" + _vm.ephemeral.severity,
            attrs: { "data-test": "bannerGeneral", "aria-live": "polite" },
          },
          [
            _c("i", { class: "icon-" + _vm.ephemeral.icon + " is-prefix" }),
            _c("div", {
              directives: [
                {
                  name: "safe-html",
                  rawName: "v-safe-html:a",
                  value: _vm.ephemeral.message,
                  expression: "ephemeral.message",
                  arg: "a",
                },
              ],
              staticClass: "c-banner-content",
            }),
          ]
        )
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-7d84fbb2_0", { source: ".l-banner[data-v-7d84fbb2] {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n.l-banner .c-banner-content[data-v-7d84fbb2] {\n  text-align: left;\n  word-break: break-word;\n}\n.l-banner[data-v-7d84fbb2]  .link {\n  color: inherit;\n  border-bottom-color: inherit;\n  font-weight: inherit;\n}\n.is-neutral[data-v-7d84fbb2] {\n  background-color: var(--text_0);\n  color: var(--background_0);\n}\n.is-danger[data-v-7d84fbb2] {\n  background-color: var(--danger_0);\n  color: var(--background_0);\n}\n\n/*# sourceMappingURL=BannerGeneral.vue.map */", map: {"version":3,"sources":["frontend/views/components/banners/BannerGeneral.vue","BannerGeneral.vue"],"names":[],"mappings":"AA6EA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AC5EA;AD8EA;EACA,gBAAA;EACA,sBAAA;AC5EA;ADgFA;EACA,cAAA;EACA,4BAAA;EACA,oBAAA;AC7EA;ADgFA;EACA,+BAAA;EACA,0BAAA;AC7EA;ADgFA;EACA,iCAAA;EACA,0BAAA;AC7EA;;AAEA,4CAA4C","file":"BannerGeneral.vue","sourcesContent":["<template lang='pug'>\n  transition-expand\n    .l-banner(\n      v-if='ephemeral.message'\n      data-test='bannerGeneral'\n      :class='`is-${ephemeral.severity}`'\n      aria-live='polite'\n    )\n      i(:class='`icon-${ephemeral.icon} is-prefix`')\n      .c-banner-content(v-safe-html:a='ephemeral.message')\n</template>\n\n<script>\nimport TransitionExpand from '../../../../frontend/views/components/TransitionExpand.vue'\nimport { debounce } from 'turtledash'\n\nexport default ({\n  name: 'BannerGeneral',\n  components: {\n    TransitionExpand\n  },\n  data: () => ({\n    ephemeral: {\n      message: null,\n      icon: null,\n      severity: null\n    }\n  }),\n  methods: {\n    // To be used by parent. Example:\n    // this.$refs.bannerGeneral.show(L('Trying to reconnect...'), 'wifi')\n    clean () {\n      this.ephemeral.message = ''\n      this.ephemeral.icon = ''\n      this.ephemeral.severity = ''\n    },\n    show (message, icon) {\n      this.ephemeral.message = message\n      this.ephemeral.icon = icon\n      this.ephemeral.severity = 'neutral'\n    },\n    danger (message, icon) {\n      this.ephemeral.message = message\n      this.ephemeral.icon = icon\n      this.ephemeral.severity = 'danger'\n    },\n    severity () {\n      return this.ephemeral.severity\n    },\n    debouncedShow ({ message, icon, seconds, clearWhen }: {\n      message: Function, icon: string, seconds: number, clearWhen: Function\n    }) {\n      let clearBannerTimer\n      return debounce((...args) => {\n        const clearBanner = () => {\n          if (clearWhen()) {\n            if (this.severity() !== 'danger') {\n              this.clean()\n            }\n            clearBannerTimer = undefined\n          } else {\n            // after first n seconds, check every half a second for clearWhen to change\n            setTimeout(clearBanner, 500)\n          }\n        }\n        if (!clearBannerTimer && !clearWhen()) {\n          this.show(message(...args), icon)\n          clearBannerTimer = setTimeout(clearBanner, 1000 * seconds)\n        }\n      }, 1000 * seconds)\n    }\n  }\n}: Object)\n</script>\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.l-banner {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n\n  .c-banner-content {\n    text-align: left;\n    word-break: break-word;\n  }\n}\n\n.l-banner ::v-deep .link {\n  color: inherit;\n  border-bottom-color: inherit;\n  font-weight: inherit;\n}\n\n.is-neutral {\n  background-color: $text_0;\n  color: $background;\n}\n\n.is-danger {\n  background-color: $danger_0;\n  color: $background;\n}\n</style>\n",".l-banner {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n.l-banner .c-banner-content {\n  text-align: left;\n  word-break: break-word;\n}\n\n.l-banner ::v-deep .link {\n  color: inherit;\n  border-bottom-color: inherit;\n  font-weight: inherit;\n}\n\n.is-neutral {\n  background-color: var(--text_0);\n  color: var(--background_0);\n}\n\n.is-danger {\n  background-color: var(--danger_0);\n  color: var(--background_0);\n}\n\n/*# sourceMappingURL=BannerGeneral.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-7d84fbb2"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "<template lang='pug'>\n  transition-expand\n    .l-banner(\n      v-if='ephemeral.message'\n      data-test='bannerGeneral'\n      :class='`is-${ephemeral.severity}`'\n      aria-live='polite'\n    )\n      i(:class='`icon-${ephemeral.icon} is-prefix`')\n      .c-banner-content(v-safe-html:a='ephemeral.message')\n</template>\n\n<script>\nimport TransitionExpand from '../../../../frontend/views/components/TransitionExpand.vue'\nimport { debounce } from 'turtledash'\n\nexport default ({\n  name: 'BannerGeneral',\n  components: {\n    TransitionExpand\n  },\n  data: () => ({\n    ephemeral: {\n      message: null,\n      icon: null,\n      severity: null\n    }\n  }),\n  methods: {\n    // To be used by parent. Example:\n    // this.$refs.bannerGeneral.show(L('Trying to reconnect...'), 'wifi')\n    clean () {\n      this.ephemeral.message = ''\n      this.ephemeral.icon = ''\n      this.ephemeral.severity = ''\n    },\n    show (message, icon) {\n      this.ephemeral.message = message\n      this.ephemeral.icon = icon\n      this.ephemeral.severity = 'neutral'\n    },\n    danger (message, icon) {\n      this.ephemeral.message = message\n      this.ephemeral.icon = icon\n      this.ephemeral.severity = 'danger'\n    },\n    severity () {\n      return this.ephemeral.severity\n    },\n    debouncedShow ({ message, icon, seconds, clearWhen }: {\n      message: Function, icon: string, seconds: number, clearWhen: Function\n    }) {\n      let clearBannerTimer\n      return debounce((...args) => {\n        const clearBanner = () => {\n          if (clearWhen()) {\n            if (this.severity() !== 'danger') {\n              this.clean()\n            }\n            clearBannerTimer = undefined\n          } else {\n            // after first n seconds, check every half a second for clearWhen to change\n            setTimeout(clearBanner, 500)\n          }\n        }\n        if (!clearBannerTimer && !clearWhen()) {\n          this.show(message(...args), icon)\n          clearBannerTimer = setTimeout(clearBanner, 1000 * seconds)\n        }\n      }, 1000 * seconds)\n    }\n  }\n}: Object)\n</script>\n<style lang=\"scss\" scoped>\n@import \"../../../../frontend/assets/style/_variables.scss\";\n\n.l-banner {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n\n  .c-banner-content {\n    text-align: left;\n    word-break: break-word;\n  }\n}\n\n.l-banner ::v-deep .link {\n  color: inherit;\n  border-bottom-color: inherit;\n  font-weight: inherit;\n}\n\n.is-neutral {\n  background-color: $text_0;\n  color: $background;\n}\n\n.is-danger {\n  background-color: $danger_0;\n  color: $background;\n}\n</style>\n"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__